import * as History from 'history';
import { parse } from 'query-string';

import { IProductDetailRouteParams } from '.';

export interface IRCVersionKeys {
  rcKey: string;
  customRcKey: string;
  customVersionKey: string;
}

export const getRcVersionKeys = (
  location: History.Location,
  params: IProductDetailRouteParams
): IRCVersionKeys => {
  let customRcKey = null;
  let customVersionKey = null;
  if (location.search.length > 0) {
    const queryS = parse(location.search);
    if (queryS.rcKey) {
      // prefer to show rc with rcKey param
      customRcKey = queryS.rcKey;
    }
    if (queryS.versionKey) {
      // prefer to show selected rich content version
      customVersionKey = queryS.versionKey;
    }
  }

  const rcKey = customRcKey || params.productUrl;

  return {
    rcKey,
    customVersionKey,
    customRcKey,
  };
};
